
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/history-american-landownership-sharecropping",
      function () {
        return require("private-next-pages/articles/history-american-landownership-sharecropping.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/history-american-landownership-sharecropping"])
      });
    }
  